/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMostOrderedItems$Params {
  VenueId?: string;
  VenueEmployeeId?: string;
}

export function getMostOrderedItems(http: HttpClient, rootUrl: string, params?: GetMostOrderedItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getMostOrderedItems.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('VenueEmployeeId', params.VenueEmployeeId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getMostOrderedItems.PATH = '/api/wtr/Menu/getmostordereditems';
